import React from 'react'
import Header from '../Header/Header'
import CurrentVideo from './CurrentVideo'

const VideoPlaying = () => {
  return (
    <div>
      <CurrentVideo/>
    </div>
  )
}

export default VideoPlaying
